import React from "react";
import { Grid, Typography } from "@material-ui/core";
import EditText from "../../components/EditText";
import { useTranslation } from "react-i18next";

const AccountView = (props) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography color="textPrimary" variant="h5">
          {t("register.account_title")}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <EditText {...props} label={t("register.username")} name="username" />
      </Grid>
      <Grid item xs={12}>
        <EditText
          {...props}
          label={t("register.password")}
          name="password"
          type="password"
        />
      </Grid>
      <Grid item xs={12}>
        <EditText
          {...props}
          label={t("register.confirm_password")}
          name="confirm_password"
          type="password"
        />
      </Grid>
    </Grid>
  );
};

export default AccountView;
